import { useEffect, useState } from "react";
import ProductCart from "../../components/ProductCart";
import { getFetcher } from "../../../api/fetchers";
import { endpoints } from "../../../api/endpoints";
import Spinner from "../../components/spinner/Spinner";
import CollectionCart from "../../components/CollectionCart";
import coll1 from "../../assets/images/coll1.png";
import coll2 from "../../assets/images/coll2.png";
import coll3 from "../../assets/images/coll3.png";
import coll4 from "../../assets/images/coll4.png";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css/navigation";
import "swiper/css";
import { Navigation } from "swiper/modules";
import left from "../../assets/images/left.png";
import right from "../../assets/images/right.png";
import rCol1 from "../../assets/images/r-col1.png";
import rCol2 from "../../assets/images/r-col2.png";
import rCol3 from "../../assets/images/r-col3.png";
import rCol4 from "../../assets/images/r-col4.png";
import novaHome from "../../assets/images/novaHome.png"
import { useLanguage } from "../../context/LanguageContext";
import { useUser } from "../../context/UserContext";
import { useNavigate } from "react-router-dom";

const collectionContents = [
  {
    title: "Varis Çorap Koleksiyonu",
    description:
      "Dolaşımı hızlandıran ve varis rahatsızlığını hafifleten varis çorapları, günlük kullanım ve terapötik destek için mükemmeldir.",
    image: coll1,
    res_image: rCol1,
    id: 8,
    colors: ["#4C3333", "#BA8F6E"],
    // image2: coll1_2,
  },
  {
    title: "Ortopedik Yastık Koleksiyonu",
    description:
      "Optimum konfor ve destek için tasarlanmış ortopedik yastıklar boyun ağrısını hafifletir ve uyku kalitesini artırır.",
    image: coll2,
    res_image: rCol2,
    id: 4,
    colors: ["#E8ACC5 ", "#95B5DA", "#9BB873"],
  },
  {
    title: "Ortopedik Ayakkabı Koleksiyonu",
    description:
      "Ortopedik ayakkabılar, ayak sağlığınız için destekleyici tasarımları ve yastıklamaları ile uzun süreli konfor sunar.",
    image: coll3,
    res_image: rCol3,
    id: 5,
    colors: ["#7190B1", "#436B9D"],
  },
  {
    title: "Visko Yastık Koleksiyonu",
    description:
      "Ortopedik ürünler ayak sağlığını desteklemek, konfor, denge ve günlük rahatlık için uygun duruş sağlamak üzere tasarlanmıştır",
    image: coll4,
    res_image: rCol4,
    id: 2,
    colors: ["#0598C7", "#141C3A"],
  },
];

const HomeProducts = () => {
  const { t } = useLanguage();
  const { user } = useUser();
  const [products, setProducts] = useState<any>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [userBusinessPackage, setUserBusinessPackage] = useState<any>();
  const navigate = useNavigate();

  const fetchProducts = async (subCategoryId: any) => {
    try {
      const productsResponse = await getFetcher(
        endpoints.products.getProductsByMainCategory.replace(
          "{id}",
          subCategoryId || ""
        )
      );

      if (productsResponse.result) {
        return productsResponse.products;
      } else {
        console.error("Error fetching products:", productsResponse.message);
        return [];
      }
    } catch (error) {
      console.error("Error fetching products:", error);
      return [];
    }
  };

  useEffect(() => {
    const fetchAllProducts = async () => {
      setLoading(true);

      const fetchedProducts: any = {};

      for (const collection of collectionContents) {
        const productsForCollection = await fetchProducts(collection.id);
        fetchedProducts[collection.id] = productsForCollection;
      }

      setProducts(fetchedProducts);
      setLoading(false);
    };

    fetchAllProducts();
  }, []);

  const fetchBusinessPackageData = async () => {
    if (user) {
      try {
        const businessPackage = await getFetcher(
          endpoints.user.getBusinessPackageById.replace(
            "{id}",
            user.businessPackageId
          )
        );
        if (businessPackage.result) {
          setUserBusinessPackage(businessPackage.businessPackage);
        }
      } catch (error) {
        console.error("Error fetching business package:", error);
      } finally {
        console.log("first");
      }
    } else {
      console.log("err");
    }
  };

  useEffect(() => {
    fetchBusinessPackageData();
  }, [user]);

  return (
    <div className=" w-full  mx-auto">
      {loading ? (
        <>
          <Spinner />
        </>
      ) : (
        <div className="flex flex-col justify-start items-center my-1 ">

          
          <div
            style={{
              backgroundImage: `url(${novaHome})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
            className="w-full h-full md:h-[300px] text-white"
          >
            <div className=" w-11/12 mx-auto p-3 mt-8 flex flex-col gap-y-4">
              <div className=" flex items-center gap-x-3">
                <h2 className=" text-yellow-color font-poppins font-normal text-[30px]">
                  {t("homeProducts", "mapTitle")}
                </h2>

              </div>
              <div>
                <h2 className=" text-[38px] md:text-[42px] text-yellow-color font-poppins">
                  {t("homeProducts", "mapDesc")}
                </h2>
              </div>
              <div>
                <h2 className=" text-[15px] md:text-[17px] text-yellow-color font-poppins">
                  {t("homeProducts", "mapAltDesc")}
                </h2>
              </div>
              <div>
                <button onClick={() => navigate('/map')} className="bg-yellow-color text-primary-color font-poppins font-[600] py-3 px-5 rounded-lg text-[14px] md:text-[16px] active:scale-90 transition-transform">
                  {t("homeProducts", "mapButton")}
                </button>
              </div>
            </div>
          </div>
          

          {collectionContents.map((collection) => {
            return (
              <div
                key={collection.id}
                className="w-full flex flex-col lg:flex-row gap-8 sm:gap-12 justify-start items-start px-6 sm:px-10 py-10 "
              >
                <div className="flex-shrink-0 flex flex-1 w-full mt-8">
                  <CollectionCart collection={collection} />
                </div>
                {products[collection.id]?.length > 0 && (
                  <Swiper
                    modules={[Navigation]}
                    navigation={{
                      nextEl: ".swiper-button-next1",
                      prevEl: ".swiper-button-prev1",
                    }}
                    breakpoints={{
                      320: {
                        slidesPerView: 1,
                        spaceBetween: 8,
                      },
                      580: {
                        slidesPerView: 3,
                        spaceBetween: 8,
                      },
                      792: {
                        slidesPerView: 4,
                        spaceBetween: 10,
                      },
                      1024: {
                        slidesPerView: 5,
                        spaceBetween: 12,
                      },
                      1060: {
                        slidesPerView: 2,
                        spaceBetween: 15,
                      },
                      1100: {
                        slidesPerView: 3,
                        spaceBetween: 15,
                      },
                      1240: {
                        slidesPerView: 4,
                        spaceBetween: 15,
                      },
                      1280: {
                        slidesPerView: 4,
                        spaceBetween: 15,
                      },
                      1600: {
                        slidesPerView: 6,
                        spaceBetween: 20,
                      },
                      1900: {
                        slidesPerView: 7,
                        spaceBetween: 20,
                      },
                    }}
                    className="w-full pt-8 lg:-mt-72 lg:relative lg:top-72 p-2"
                  >
                    {/* {fakeProducts?.map((product: any, index: any) => (
                        <SwiperSlide
                          key={index}
                          className="flex justify-center items-center"
                        >
                          <ProductCart product={product} />
                        </SwiperSlide>
                      ))} */}
                    {collection?.id == 4
                      ? products[4]
                        ?.slice(9)
                        ?.map((product: any, index: any) => {
                          return (
                            <SwiperSlide
                              key={index}
                              className="flex justify-center items-center px-2"
                            >
                              <ProductCart
                                product={product}
                                userBusinessPackage={userBusinessPackage}
                              />
                            </SwiperSlide>
                          );
                        })
                      : products[collection.id]?.map(
                        (product: any, index: any) => (
                          <SwiperSlide
                            key={index}
                            className="flex justify-center items-center px-2"
                          >
                            <ProductCart
                              product={product}
                              userBusinessPackage={userBusinessPackage}
                            />
                          </SwiperSlide>
                        )
                      )}
                    <div className="mt-12 flex justify-center items-center">
                      <div className=" w-full flex justify-center gap-x-5 ">
                        <img
                          loading="lazy"
                          src={left}
                          alt="left"
                          className=" cursor-pointer active:scale-90 transition-transform swiper-button-prev1"
                        />
                        <img
                          loading="lazy"
                          src={right}
                          alt="right"
                          className=" cursor-pointer active:scale-90 transition-transform swiper-button-next1"
                        />
                      </div>
                    </div>
                  </Swiper>
                )}
              </div>
            );
          })}
        </div>
      )}

      <div className="w-full py-14 bg-[#F3F3F3] flex justify-center items-center flex-col gap-y-3 flex-nowrap px-4 font-poppins font-semibold text-xl md:text-[29px] lg:text-[39px] text-[#141C3A] mt-14">
        <p className="flex flex-wrap gap-x-2 text-center justify-center">
          {t("homeProducts", "text1")}
          <span className="text-yellow-color">
            {" "}
            {t("homeProducts", "text2")}{" "}
          </span>
          {t("homeProducts", "text3")}
        </p>

        <p className="w-full md:w-7/12 lg:w-6/12 xl:w-4/12 text-center font-inter font-normal text-[14px] text-black mt-4">
          {t("homeProducts", "desc")}
        </p>
      </div>
    </div>
  );
};

export default HomeProducts;
